module.exports = __webpack_public_path__ + "static/img/jxslogo2.e3896ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jxslogo2.png
// module id = 3mjO
// module chunks = 113